import { useCallback, useEffect, useState } from "react";

const KEY = "itly-theme";
const EVT = "itly-theme-change";

export function resolveTheme() {
    const stored = localStorage.getItem(KEY);
    if (stored === "dark" || stored === "light") return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(theme) {
    document.documentElement.dataset.theme = theme;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "dark" ? "#0C1615" : "#0F3D3E");
}

export function useTheme() {
    const [theme, setThemeState] = useState(resolveTheme);

    useEffect(() => {
        const onChange = () => setThemeState(resolveTheme());
        const mq = window.matchMedia("(prefers-color-scheme: dark)");
        window.addEventListener(EVT, onChange);
        mq.addEventListener("change", onChange);
        return () => {
            window.removeEventListener(EVT, onChange);
            mq.removeEventListener("change", onChange);
        };
    }, []);

    const toggle = useCallback(() => {
        const next = resolveTheme() === "dark" ? "light" : "dark";
        localStorage.setItem(KEY, next);
        applyTheme(next);
        window.dispatchEvent(new Event(EVT));
    }, []);

    return { theme, toggle };
}
